var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Toolbar',{attrs:{"toolbarTitle":_vm.$t(_vm.toolbarTitle),"showDrawer":false,"lastPath":-1,"tooltipMessage":"Hier können Sie das gewünschte Element löschen."},on:{"backEmit":_vm.backEmit}}),_c('DeleteConfirm',{attrs:{"deleteMessage":_vm.deleteMessage,"selectedItem":_vm.getSelectedTaskArchive.data},on:{"deleteItem":_vm.deleteItem}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }